<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">{{ this.$store.getters.TRANSLATIONS["history"] }}</p>
      </div>
      <p class="content_title">
        {{ this.$store.getters.TRANSLATIONS["pick_a_car"] }}
        <br />{{ this.$store.getters.TRANSLATIONS["history"] }}
      </p>
      <div
        class="car"
        v-for="item in vehicles"
        :key="item.id"
        v-on:click="next(item)"
      >
        <div class="vehicle">
          <button class="button start">
            {{ item.make || "" }} {{ item.model || "" }}
          </button>
          <button class="button end">{{ item.color || "" }}</button>
        </div>
      </div>
    </div>
    <div class="footer" v-if="!loading"></div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("login");
    } else {
      this.vehicles = this.$store.getters.USER.vehicles;
    }
  },
  data() {
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      vehicles: [],
      next: (item) => {
        if (
          !this.$store.getters.USER.vehicles[
            this.$store.getters.USER.vehicles.findIndex((v) => v.id === item.id)
          ].places
        ) {
          const timeout = setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$http
            .get(
              `${process.env.SERVER_URL}/27B3541B734843698D9AEB7D970B8AFC/${item.id}`,
              {
                headers: {
                  "x-access-token": this.$storage.get("parkendaToken")
                }
              }
            )
            .then((response) => {
              console.log("Get vehicle places response:");
              console.log(response);
              let User = this.$store.getters.USER;
              User.vehicles[
                User.vehicles.findIndex((v) => v.id === item.id)
              ].places = response.data;
              User.historySelectedVehicleId = item.id;
              this.$store.dispatch("SAVE_USER", User);
            })
            .catch((error) => {
              let text =
                this.$store.getters.TRANSLATIONS["something_went_wrong"];
              if (
                error.response &&
                error.response.data &&
                error.response.data.error
              ) {
                text = error.response.data.error;
              }
              this.$modal.show("dialog", {
                text,
                buttons: [
                  {
                    title: "OK",
                    handler: () => {
                      this.$storage.remove("parkendaToken");
                      this.$router.push("login");
                    }
                  }
                ]
              });
            })
            .finally(() => {
              clearTimeout(timeout);
              this.loading = false;
              this.$router.push("historyVehiclePlaces");
            });
        } else {
          let User = this.$store.getters.USER;
          User.historySelectedVehicleId = item.id;
          this.$store.dispatch("SAVE_USER", User);
          this.$router.push("historyVehiclePlaces");
        }
      },
      back: () => {
        this.$router.push("currentParking");
      },
      icon: require("@/assets/icon_back.png"),
      nextIcon: require("@/assets/nextArrowIos.jpg")
    };
  }
};
</script>

<style src="../../styles/main.css"></style>
<style scoped>
.vehicle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.start {
  background-color: white;
  color: #fbae31;
  text-align: left;
  padding-left: 10px;
  margin-left: 17vw;
}
.end {
  width: 20%;
  background-color: #fbae31;
  color: white;
  margin-right: 48px;
}
</style>



// WEBPACK FOOTER //
// src/components/History/Vehicles.vue